export enum RescheduleReason {
  BadWeather = 'bad-weather',
  EquipmentIssue = 'equipment-issue',
  WinterCondition = 'winter-condition',
  FlightMarkerDelay = 'flight-marker-delay',
  PilotUnavailability = 'pilot-unavailability',
  ClientRequest = 'client-request',
  Other = 'other',
}
